import { putMedia } from '../api/putMedia';

export const setPutMedia = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putMedia(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}